export default __webpack_public_path__ + "static/media/Gotham-Medium.98191450.woff2";